<form class="k-form k-form-horizontal" style="max-width: 800px;width: 800px;" [formGroup]="editForm">
  <kendo-grid #grid [data]="gridData" (cellClick)="cellClickHandler($event)" (cellClose)="cellCloseHandler($event)">
    <kendo-grid-column field="nome" [width]="100" [editable]="false"
      [title]="customMsgService.translate('artigos')"> </kendo-grid-column>

    <kendo-grid-column field="numeroDeFerramentasDoTipo" [width]="100" [editable]="false"
      [title]="customMsgService.translate('artigos')"> </kendo-grid-column>

    <kendo-grid-column field="numeroDeFerramentasDoTipoDisponiveis" [width]="150" [editable]="false"
      [title]="customMsgService.translate('artigos')"> </kendo-grid-column>

    <kendo-grid-column field="numeroDeFerramentasAutorizadas"
      [title]="customMsgService.translate('artigos')" [width]="140" editor="numeric">
      <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
        <span>{{this.customMsgService.translate('artigos')}} </span>
        <button kendoButton icon="pencil" (click)="InfoButton()"></button>
      </ng-template>
    </kendo-grid-column>

  </kendo-grid>
  <div class="k-form-buttons">
    <button kendoButton [primary]="true" (click)="saveChanges()">
      {{ customMsgService.translate('saveChanges') }}
    </button>
  </div>
</form>